/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

const incomeExpenseSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "incomeexpense",

  initialState: {
    //INCOME & EXPENSES
    monthlyIncome: "0.00",
    monthlyExpenses: "0.00",
    annualIncome: "0.00",
    annualExpenses: "0.00",
    noIncomeExpensesReason: "",

    //CPF - INCOME
    ordinaryaccount: "0.00",
    specialaccount: "0.00",
    medisaveaccount: "0.00",
    noCpfInFlowReason: "",
    cpfInflowTotal: "0.00",

    //CPF - EXPENSES
    ordinaryAcctMortgage: "0.00",
    ordinaryAcctInvestment: "0.00",
    specialAcctInvestment: "0.00",
    medisaveAcctOutflow: "0.00",
    noCpfOutFlowReason: "",
    cpfOutFlowTotal: "0.00",

    haveInExImpact: "",
    cpfInExFlowImpactDesc: "",

    totalAnnualCashFlow: "0.00",
  },

  reducers: {
    updateIncomeExpense: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "monthlyIncome":
          state.monthlyIncome = payload;
          break;

        case "annualIncome":
          state.annualIncome = payload;
          break;

        case "monthlyExpenses":
          state.monthlyExpenses = payload;
          break;

        case "annualExpenses":
          state.annualExpenses = payload;
          break;

        case "noIncomeExpensesReason":
          state.noIncomeExpensesReason = payload;
          break;

        default:
          break;
      }
    },

    updateCPFIncomeExpense: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        //CPF INCOME
        case "ordinaryaccount":
          state.ordinaryaccount = payload;
          break;

        case "specialaccount":
          state.specialaccount = payload;
          break;

        case "medisaveAcct":
          state.medisaveaccount = payload;
          break;

        case "cpfInflowTotal":
          state.cpfInflowTotal = payload;
          break;

        case "noCpfInFlowReason":
          state.noCpfInFlowReason = payload;
          break;

        //CPF EXPENSE
        case "ordinaryAcctMortgage":
          state.ordinaryAcctMortgage = payload;
          break;

        case "ordinaryAcctInvestment":
          state.ordinaryAcctInvestment = payload;
          break;

        case "specialAcctInvestment":
          state.specialAcctInvestment = payload;
          break;

        case "medisaveAcctOutflow":
          state.medisaveAcctOutflow = payload;
          break;

        case "noCpfOutFlowReason":
          state.noCpfOutFlowReason = payload;
          break;

        case "cpfOutlowTotal":
          state.cpfOutFlowTotal = payload;
          break;

        default:
          break;
      }
    },

    updateTotals: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "totalAnnualCashFlow":
          state.totalAnnualCashFlow = payload;
          break;

        default:
          break;
      }
    },

    updateImpact: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "haveInExImpact":
          state.haveInExImpact = payload;
          break;

        case "cpfInExFlowImpactDesc":
          state.cpfInExFlowImpactDesc = payload;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateIncomeExpense, updateCPFIncomeExpense, updateTotals, updateImpact } = incomeExpenseSlice.actions;

export default incomeExpenseSlice.reducer;
